// extracted by mini-css-extract-plugin
export var promotionLink = "_vu-0";